/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeWorkingModeDetailPublishAs } from './scheduledChangeWorkingModeDetailPublishAs';
import type { ScheduledChangeWorkingModeDetailDraftVersion } from './scheduledChangeWorkingModeDetailDraftVersion';
import type { ScheduledChangeWorkingModeChange } from './scheduledChangeWorkingModeChange';
import type { ScheduledChangeWorkingModeDetailReason } from './scheduledChangeWorkingModeDetailReason';

export interface ScheduledChangeWorkingModeDetail {
  targetMode: string;
  publishAs?: ScheduledChangeWorkingModeDetailPublishAs;
  draftVersion?: ScheduledChangeWorkingModeDetailDraftVersion;
  changes?: ScheduledChangeWorkingModeChange[];
  reason?: ScheduledChangeWorkingModeDetailReason;
}
